import { HelpIcon } from '@change/ds-icons';

import { Card, Text } from '@change/ds-core-ui/next';

import type { NormalizedDecisionMaker } from '../../../../shared/types';
import { AvatarAndBadge } from '../../../shared/AvatarAndBadge';
import { DecisionMakerResponse } from '../../../shared/DecisionMakerResponse';
import { Location } from '../../../shared/Location';
import { Name } from '../../../shared/Name';
import { ResponseBadge } from '../../../shared/ResponseBadge';
import { SignersText } from '../../../shared/SignersText';

export const DecisionMakerCardDesktop: React.FC<{ dm: NormalizedDecisionMaker }> = ({ dm }) => {
	const { displayName, id, location, title, photoUrl, publiclyVisible, signersText, slug, response } = dm;
	return (
		<Card className="mb-6 hidden bg-white p-6 pb-8 shadow-md lg:block">
			<div className="flex gap-4">
				<div>
					<AvatarAndBadge displayName={displayName} photoUrl={photoUrl} />
				</div>

				<div className="w-full">
					<div className="flex w-full flex-col xl:flex-row">
						<div className="w-full">
							<div className="mr-1 flex w-full">
								<div className="flex items-center">
									<Name displayName={displayName} id={id} publiclyVisible={publiclyVisible} slug={slug} />
								</div>

								<div className="ml-auto">
									<ResponseBadge response={response} />
								</div>
							</div>

							<div>
								<Text variant="body" className="mb-2 mr-2">
									{title}
								</Text>
								<HelpIcon size={15} className="text-icon-strong mr-1 inline-block" />
							</div>
						</div>
					</div>

					<div className="mb-4 mt-1 flex min-h-5">
						{location && <Location location={location} />}
						{signersText && <SignersText signersText={signersText} />}
					</div>

					{response && <DecisionMakerResponse response={response} />}
				</div>
			</div>
		</Card>
	);
};
